/* LB 27-09-2026 (Ayoub: "arregla la galería y eso").
   1) Móvil: el logo del header (202 px, tamaño original) se pisaba con la lupa. Ayoub quiere el logo a tamaño original
      y la lupa más pegada al carrito: se desplazan los iconos a la derecha (lupa 12 px, cesta 4 px) y el logo 8 px a la
      izquierda (sigue centrado verticalmente) con transform en línea (!important), porque otras reglas del tema con
      !important ganan a cualquier hoja de estilos.
   2) Ficha de producto (móvil): la galería abría en la foto de la variante preseleccionada (p. ej. 7/16 en Milo) en vez
      de la primera (la foto principal / la del anuncio). La galería móvil es un carrusel infinito con 3 copias de las
      fotos (48 = 16 x 3): se coloca en la PRIMERA foto de la copia central. Otro script del tema la vuelve a mover a la
      foto de la variante al cambiar el tamaño/visibilidad de la ventana, así que mientras el cliente no toque la galería
      se vuelve a colocar en la primera. En cuanto el cliente la toca (o elige color), ya no se toca nada.
      No actúa si la URL trae ?variant=. */
(function () {
  'use strict';
  function isMobile() { return window.matchMedia('(max-width: 749px)').matches; }
  function fixIcons() {
    var mobile = isMobile();
    var pairs = [
      ['details-modal.header__search', 'translateX(12px)'],
      ['.header__icons .header__icon--cart', 'translateX(4px)'],
      ['.lb-header-logo-center', 'translate(calc(-50% - 8px), -50%)']
    ];
    pairs.forEach(function (p) {
      document.querySelectorAll(p[0]).forEach(function (el) {
        if (mobile) el.style.setProperty('transform', p[1], 'important');
        else el.style.removeProperty('transform');
      });
    });
  }

  var touched = false;
  function markTouched() { touched = true; }
  function altOf(li) { var i = li && li.querySelector('img'); return i ? (i.getAttribute('alt') || i.getAttribute('src') || '') : ''; }
  function targetLeft(ul) {
    var lis = ul.children;
    var n = lis.length;
    if (!n) return null;
    var target = lis[0];
    if (n >= 6 && n % 3 === 0) {
      var third = n / 3;
      var a0 = (lis[0].getAttribute('data-media-id') || altOf(lis[0]));
      var a1 = (lis[third].getAttribute('data-media-id') || altOf(lis[third]));
      if (a0 && a0 === a1) target = lis[third];
    }
    return target.offsetLeft - lis[0].offsetLeft;
  }
  function galleryToFirst() {
    if (touched || !isMobile() || /[?&]variant=/.test(window.location.search)) return;
    var ul = document.querySelector('media-gallery ul.product__media-list');
    if (!ul) return;
    var left = targetLeft(ul);
    if (left === null || Math.abs(ul.scrollLeft - left) < 5) return;
    try { ul.scrollTo({ left: left, behavior: 'auto' }); } catch (e) { ul.scrollLeft = left; }
  }
  var snapTimer = null;
  function scheduleSnap() {
    if (touched) return;
    if (snapTimer) window.clearTimeout(snapTimer);
    snapTimer = window.setTimeout(galleryToFirst, 250);
  }

  function init() {
    fixIcons();
    window.addEventListener('resize', fixIcons, { passive: true });
    window.setTimeout(fixIcons, 800);
    window.setTimeout(fixIcons, 2500);
    var ul = document.querySelector('media-gallery ul.product__media-list');
    if (!ul) return;
    ['touchstart', 'pointerdown', 'wheel', 'keydown'].forEach(function (ev) {
      ul.addEventListener(ev, markTouched, { passive: true });
    });
    var gallery = ul.closest('media-gallery') || document;
    gallery.addEventListener('click', markTouched, true);
    document.querySelectorAll('variant-selects, variant-radios, .lb-pack, [class*="lb-pack"], .product-form__input').forEach(function (el) {
      el.addEventListener('change', markTouched, true);
      el.addEventListener('click', markTouched, true);
    });
    ul.addEventListener('scroll', scheduleSnap, { passive: true });
    window.addEventListener('resize', scheduleSnap, { passive: true });
    document.addEventListener('visibilitychange', scheduleSnap);
    [0, 400, 1200, 2000, 3500, 6000].forEach(function (ms) { window.setTimeout(galleryToFirst, ms); });
    window.addEventListener('load', function () { window.setTimeout(galleryToFirst, 300); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();

/* LB 07-10-2026 (Ayoub: "ese problema de 9 MB, reparar" y "el aviso de cookies, que desaparezca al tocar fuera").
   A) Galería del producto en móvil: otro script del tema (custom-live-…-scroll17.js) hace 3 copias de las fotos (48 = 16 x 3)
      y obligaba a descargarlas TODAS al abrir la página (varios MB aunque el cliente solo vea una foto).
      Este archivo se carga antes que ese script: ahora las fotos de la galería se quedan en "carga diferida" y solo se bajan
      la que se ve, la siguiente (1,5 s después de cargar la página) y, cuando el cliente toca la galería, las 2 de cada lado.
   B) Fotos subidas a Archivos y puestas sin tamaño (p. ej. 800 KB cada una): se piden al ancho que ocupan en pantalla.
   C) Aviso de cookies: se cierra al tocar fuera de él. NO acepta nada: el visitante queda "sin decidir" (igual que si no lo
      toca) y puede cambiarlo en "Preferencias de cookies" del pie. Se recuerda cerrado durante la visita. */
(function () {
  'use strict';
  /* A */
  try {
    var d = Object.getOwnPropertyDescriptor(HTMLImageElement.prototype, 'loading');
    var GAL = 'ul.product__media-list';
    if (d && d.set && d.get) {
      Object.defineProperty(HTMLImageElement.prototype, 'loading', {
        configurable: true, enumerable: d.enumerable,
        get: function () { return d.get.call(this); },
        set: function (v) {
          try { if (v === 'eager' && !this.__lbGo && this.closest && this.closest(GAL)) return; } catch (e) {}
          d.set.call(this, v);
        }
      });
      var go = function (img) { try { img.__lbGo = 1; d.set.call(img, 'eager'); } catch (e) {} };
      var near = function (left, right) {
        var g = document.querySelector(GAL); if (!g) return;
        var w = window.innerWidth || 375, h = window.innerHeight || 800, imgs = g.querySelectorAll('img[loading="lazy"]');
        for (var i = 0; i < imgs.length; i++) {
          var r = imgs[i].getBoundingClientRect();
          if (r.width && r.right > left * w && r.left < right * w && r.bottom > -600 && r.top < h + 600) go(imgs[i]);
        }
      };
      var touched = false, timer = null;
      var onScroll = function () {
        if (!touched || timer) return;
        timer = window.setTimeout(function () { timer = null; near(-1.6, 2.6); }, 120);
      };
      var start = function () {
        var g = document.querySelector(GAL); if (!g) return;
        var wrap = g.closest('media-gallery') || g;
        var touch = function () { if (!touched) { touched = true; near(-1.6, 2.6); } };
        ['touchstart', 'pointerdown', 'wheel', 'keydown', 'click'].forEach(function (ev) {
          wrap.addEventListener(ev, touch, { passive: true, capture: true });
        });
        g.addEventListener('scroll', onScroll, { passive: true });
        var next = function () { window.setTimeout(function () { near(0.5, 1.6); }, 1500); };
        if (document.readyState === 'complete') next(); else window.addEventListener('load', next, { once: true });
      };
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true }); else start();
    }
  } catch (e) {}

  /* B */
  var sized = function () {
    try {
      var imgs = document.querySelectorAll('img[loading="lazy"]:not([srcset])');
      var dpr = Math.min(window.devicePixelRatio || 1, 2);
      for (var i = 0; i < imgs.length; i++) {
        var s = imgs[i].getAttribute('src') || '';
        if (!/^(https:)?\/\/cdn\.shopify\.com\/s\/files\/|^(https:\/\/[^\/]+)?\/cdn\/shop\/files\//.test(s)) continue;
        if (/[?&]width=/.test(s) || !/\.(jpe?g|png|webp)(\?|$)/i.test(s)) continue;
        var slot = imgs[i].getBoundingClientRect().width || 400;
        var w = Math.max(400, Math.min(1600, Math.ceil(slot * dpr / 100) * 100));
        imgs[i].setAttribute('src', s + (s.indexOf('?') > -1 ? '&' : '?') + 'width=' + w);
      }
    } catch (e) {}
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sized, { once: true }); else sized();

  /* C */
  try {
    var KEY = 'lb_ck_cerrado';
    var hideBanner = function () {
      if (document.getElementById('lb-ck-off')) return;
      var st = document.createElement('style'); st.id = 'lb-ck-off';
      st.textContent = '#shopify-pc__banner{display:none!important}';
      (document.head || document.documentElement).appendChild(st);
    };
    try { if (window.sessionStorage.getItem(KEY) === '1') hideBanner(); } catch (e) {}
    document.addEventListener('pointerdown', function (e) {
      var b = document.getElementById('shopify-pc__banner');
      if (!b || document.getElementById('lb-ck-off')) return;
      if (b.contains(e.target)) return;
      var p = document.getElementById('shopify-pc__prefs');
      if (p && p.contains(e.target)) return;
      hideBanner();
      try { window.sessionStorage.setItem(KEY, '1'); } catch (err) {}
    }, { passive: true, capture: true });
  } catch (e) {}
})();
